import { planTypes } from '@/common/constants';

const planType = planTypes.ROOM_CONNECTOR;

export default {
  key: planTypes[planType],
  data() {
    return {
      planType,
      title: this.$t('billing.planform.title.rc'),
      logo: require('@/assets/plans/conference_room_connector.svg'),
    };
  },
};